import { render, staticRenderFns } from "./CreatePricing.vue?vue&type=template&id=1c056e48"
import script from "./CreatePricing.vue?vue&type=script&lang=js"
export * from "./CreatePricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports